import KanbanBoard from './KanbanBoard';

export default KanbanBoard;
